import { Subject } from 'rxjs';

const subject = new Subject();

export const teamMemberTourGuideService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};